import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter, MemoryRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { useNavigate, useParams } from "react-router-dom";
import { pathRoutes } from "../props/util.props";
import useFetch, { CachePolicies } from "use-http";
import { AppContext } from "src/pages/context/App.context";
import { useBeforeunload } from "react-beforeunload";
// import UILoading from "../pages/firstPage/UILoading";
// import Route from "./Route";
import * as Auth from "../service/auth.service";
import { Col, Layout, Result, Row, } from 'antd';
// import UILeftMenuMainPage from "../components/shared/leftMenu/UILeftMenuMainPage";

// const LoginMain = React.lazy(() => import("src/pages/login/LoginMain"));
// const Home = React.lazy(() => import("src/pages/Home/Home"));
// const UIMicroAppPD = React.lazy(() => import("src/pages/microAppFromPD/UIMicroAppPD"));
// const Apps = React.lazy(() => import("src/pages/Apps/Apps"));
import { CaseDesignDocument } from "../pages/CaseDesignDocument/CaseDesignDocument";
import { VideoCall } from "src/pages/videoCall/videoCall/VideoCall";

// import UIMainPage from "src/components/shared/leftMenu/UILeftMenuMainPage";
import UILeftMenuMainPage from "src/components/shared/leftMenu/UILeftMenuMainPage";
import UILoading from "src/pages/firstPage/UILoading";
import ShowReportPost from "src/pages/ShowReportPost/ShowReportPost";
import TestOrgChart from "src/pages/TestOrgChart/TestOrgChart";
import OrgChartColleagues from "src/components/OrgChart/OrgChartColleagues/OrgChartColleagues";
import PrivateRoute from "./PrivateRoute";
import Posts from "../pages/Profile/Posts/Posts";
import Requests from "../pages/MyCenter/Requests";
import Save from "../pages/Profile/Save/Save";
import Friends from "../components/Friends";
import Groups from "../pages/Profile/Groups/Groups";
import Lives from "../pages/Profile/Lives/Lives";
import { Files, UICoFileCommunity } from "../pages/filePage/UICoFile";
import CommunityNewFeed from "../pages/Group/Community/CommunityNewFeed";
import CommunityMemberManage from 'src/pages/Group/Community/CommunityMemberManage';
import InviteChat from "../pages/chatPage/InviteChat";
import ChatGroupCommunity from "../pages/Group/Community/chat/ChatGroupCommunity";
import PrivacyCommunitySetting from "../pages/Group/Community/PrivacyCommunitySetting";
import Conferences from "src/pages/Profile/VideoConferences/Conference";
import styles from "../pages/firstPage/UIFirstPage.module.scss";
import LogoLoading from "../pages/firstPage/LogoLoading";
import TestGroupWS from "../pages/testWebSocket/TestGroupWS";

const LoginMain = React.lazy(() => import("../pages/login/LoginMain"));
const UIFirstPage = React.lazy(() => import("src/pages/firstPage/UIFirstPage"));
const Group = React.lazy(() => import("../pages/Group/Group"));
const createGroup = React.lazy(() => import("../pages/Group/CreateGroup"));
const UIFeed = React.lazy(() => import("src/pages/feed/UIFeed"));
const CenterLayout = React.lazy(() => import("../layouts/CenterLayout"));
const Apps = React.lazy(() => import("src/pages/Apps/Apps"));
const Home = React.lazy(() => import("src/pages/Home/Home"));
const UIMicroApp = React.lazy(
  () => import("src/pages/microAppPage/UIMicroApp")
);
const UIMicroAppPD = React.lazy(
  () => import("src/pages/microAppFromPD/UIMicroAppPD")
);
const UICoFile = React.lazy(() => import("src/pages/filePage/UICoFile"));
const UIChat = React.lazy(() => import("src/pages/chatPage/UIChat"));

const CreateGroup = React.lazy(() => import("src/pages/Group/CreateGroup"));
const Profile = React.lazy(() => import("src/pages/Profile/Profile"));
const MyCenter = React.lazy(() => import("src/pages/MyCenter"));
const CreateAccount = React.lazy(
  () => import("src/pages/CreateAccount/CreateAccount")
);
const Setting = React.lazy(() => import("src/pages/Setting/Setting"));
const ActionCenter = React.lazy(
  () => import("src/pages/ActionCenter/ActionCenter")
);
const NewActionCenter = React.lazy(
  () => import("src/pages/ActionCenter/NewActionCenter")
);
const AddFile = React.lazy(() => import("src/pages/filePage/AddFile"));
const Live = React.lazy(() => import("src/pages/Live/Live"));
const LiveOnDemand = React.lazy(
  () => import("../pages/Live/LiveOnDemand/LiveOnDemand")
);
const Call = React.lazy(() => import("src/pages/videoCall/call/Call"));
const UICheckIn = React.lazy(
  () => import("src/pages/Profile/CheckIn/UICheckIn")
);
const Stream = React.lazy(() => import("src/pages/Stream/Stream"));
const StreamSeeMore = React.lazy(
  () => import("src/pages/Stream/StreamSeeMore")
);
const TestChatWs = React.lazy(
  () => import("src/pages/testWebSocket/TestChatWs")
);
const MainTestWebSocket = React.lazy(
  () => import("src/pages/testWebSocket/TestWebSocket")
);
const StreamForUser = React.lazy(
  () => import("src/pages/StreamForUser/StreamForUser")
);
const LoginStream = React.lazy(() => import("src/pages/login/LoginStream"));
const Citizenprofile = React.lazy(
  () => import("src/pages/citizenprofile/Citizenprofile")
);
const CenterCitizenprofile = React.lazy(
  () => import("src/pages/citizenprofile/CenterCitizenprofile")
);
const StreamInfo = React.lazy(
  () => import("src/pages/Stream/StreamInfo/StreamInfo")
);
const StreamInfoWatch = React.lazy(
  () => import("src/pages/Stream/StreamInfo/StreamInfoWatch")
);
const UIVideo = React.lazy(() => import("../pages/Video/UIVideo"));
const UICoFileAccess = React.lazy(
  () => import("src/pages/filePage/file-access/UICoFileAccess")
);
const Community = React.lazy(
  () => import("src/pages/Group/Community/Community")
);
const ConferenceOptions = React.lazy(
  () => import("src/pages/videoCall/videoGroup/ConferenceOptions")
);
const VideoConference = React.lazy(
  () => import("src/pages/videoCall/VideoConference/VideoConferenceV2")
);
const VideoCallV2 = React.lazy(
  () => import("../pages/videoCall/videoCall/VideoCallV3")
);
const NotFound = React.lazy(() => import("src/pages/login/NotFound"));
const NotFoundPrivate = React.lazy(
  () => import("src/pages/login/NotFoundPrivate")
);
const InitHeadStart = React.lazy(
  () => import("src/pages/DevTool/InitHeadStart/InitHeadStart")
);
const Game = React.lazy(() => import("src/pages/game/Game"));
const VirtualBackground = React.lazy(
  () => import("src/pages/videoCall/VideoConference/VirtualBackground")
);
const Board = React.lazy(() => import("../components/whiteboard"));
const GoogleLogin = React.lazy(
  () => import("src/pages/SocialLogin/GoogleLogin")
);
const FacebookLogin = React.lazy(
  () => import("src/pages/SocialLogin/FacebookLogin")
);
const AzureLogin = React.lazy(
  () => import("src/pages/SocialLogin/AzureLogin")
);
const TestBoard = React.lazy(
  () => import("src/components/whiteboard/test/testBoard")
);
const TestBoard2 = React.lazy(
  () => import("src/components/whiteboard/test/testBoard2")
);
const CollaborationBoard = React.lazy(
  () => import("src/components/whiteboard/CollaborationBoard")
);
const UICustom = React.lazy(() => import("../pages/CustomMenu/UICustom"));
const UIFirstPageStream = React.lazy(
  () => import("src/pages/StreamForUser/firstPage/UIFirstPageStream")
);
const UserReward = React.lazy(() => import("../pages/UserReward/UserReward"));
const UICaseDesignMaster = React.lazy(
  () => import("src/pages/CaseDesign/UICaseDesignMaster")
);
const AddNewDocument = React.lazy(
  () => import("src/pages/CaseDesign/AddNewDocument")
);
const HomeCaseManagement = React.lazy(
  () => import("src/pages/CaseManagementHome/HomeCaseManagement")
);
const SettingCaseManagement = React.lazy(
  () => import("src/pages/SettingCaseManagement/SettingCaseManagement")
);
const ViewAllDocuments = React.lazy(
  () => import("src/pages/CaseManagementHome/component/ViewAllDocuments")
);
const CaseDetails = React.lazy(
  () => import("src/pages/CaseManagementCaseDetails/CaseDetails")
);
const Template = React.lazy(
  () => import("../pages/CaseManagementTemplete/Template")
);
const TemplateInfo = React.lazy(
  () => import("../pages/CaseManagementTemplete/TemplateInfo")
);
const TestKanban = React.lazy(() => import("src/pages/testKanban"));
const TestRuntimeEnv = React.lazy(() => import("src/pages/TestRuntimeEnv/TestRuntimeEnv"))
const Privacy = React.lazy(() => import("src/pages/Privacy/Privacy"));
const TestCard = React.lazy(() => import("src/pages/TestCard/TestCard"));
const Normal = React.lazy(() => import("src/pages/TestLazyLoad/TestLazyLoad"));
const TestGojs = React.lazy(() => import("src/pages/TestGojs/TestGojs"));
const Rule = React.lazy(() => import("src/pages/CaseManagementRule/Rule"));
const SettingRule = React.lazy(
  () => import("src/pages/CaseManagementRule/SettingRule")
);
const Conference = React.lazy(() => import("src/pages/Conference"));
const Integration = React.lazy(() => import("src/pages/Integration/Integration"));
const SettingIntegration = React.lazy(() => import("src/pages/Integration/SettingIntegration"));
const Organization = React.lazy(() => import("src/pages/CaseManagementOrganization/Organization"));
const SettingOrganization = React.lazy(() => import("src/pages/CaseManagementOrganization/SettingOrganization"));

export function MainRoutes() {
  // const navigate = useNavigate();
  const appContext: any = useContext(AppContext);
  const objAccessAPI = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL +
    "/api/v1/object-access/get-object-access",
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const responseObjectAccess = async () => {
    const dataObj = await objAccessAPI.get();
    // console.log("data", dataObj);
    localStorage.setItem("object-access", JSON.stringify(dataObj));
    appContext.setObjectAccesses(dataObj);
  };

  useEffect(() => {
    const isObjAccess: any = localStorage.getItem("object-access");
    if (!isObjAccess) {
      let dataObjectAccesses = JSON.parse(isObjAccess);
      if (!isObjAccess) {
        responseObjectAccess();
      } else {
        appContext.setObjectAccesses(dataObjectAccesses);
      }
    } else {
      responseObjectAccess();
    }
  }, []);

  useEffect(() => {
    window.addEventListener(
      "message",
      function (e) {
        if (e.data?.event === "formStart") {
          console.log("e => ", e);
          let addCaseModal = document.getElementById("add_case_modal");
          if (addCaseModal) {
            addCaseModal.style.display = "none";
          }
          if (e?.data?.data === "submit") {
            let elem = document.getElementById("add_case_modal");
            if (!elem) return

            elem.dispatchEvent(new CustomEvent("formStartEvt", { detail: e.data }));
          }
        } else if (e.data?.event === "formSubmit") {
          let addCaseModal = document.getElementById("add_case_modal");
          if (addCaseModal) {
            addCaseModal.style.display = "none";
          }
          let backDrop = document.getElementById("form-backdrop");
          if (backDrop) {
            backDrop.classList.remove("show");
            backDrop.classList.add("hide");
            backDrop.style.display = "none";
          }
          let modal = document.getElementById("form-modal");
          if (modal) {
            modal.classList.remove("show");
            modal.classList.add("hide");
            modal.style.display = "none";
          }
          if (e?.data?.data === "submit") {
            let elem = document.getElementById("case-design");
            if (elem) {
              elem.dispatchEvent(
                new CustomEvent("formSubmitEvt", {
                  detail: { data: "submit" },
                })
              );
            }
          }
        } else if (e.data?.event === "microApp") {
          var x = document.getElementsByTagName("BODY")[0];
          if (!x) return
          x.dispatchEvent(new CustomEvent("microAppEvt", { detail: e.data }));

        }
        // console.log('received message:  ' + e.data, e);
        // addCaseModal.style.display = "none"
      },
      false
    );
    // window.addEventListener('message', function(e) {
    //     console.log('received message:  ' + e.data, e);
    // }, false);
    // @ts-ignore
    window["formSubmit"] = function (action: string) {
      console.log("formSubmit");
      if (action === "submit") {
        let backDrop = document.getElementById("form-backdrop");
        if (backDrop) {
          backDrop.classList.remove("show");
          backDrop.classList.add("hide");
          backDrop.style.display = "none";
        }
        let modal = document.getElementById("form-modal");
        if (modal) {
          modal.classList.remove("show");
          modal.classList.add("hide");
          modal.style.display = "none";
        }
      } else if (action === "cancel") {
        let backDrop = document.getElementById("form-backdrop");
        if (backDrop) {
          backDrop.classList.remove("show");
          backDrop.classList.add("hide");
          backDrop.style.display = "none";
        }
        let modal = document.getElementById("form-modal");
        if (modal) {
          modal.classList.remove("show");
          modal.classList.add("hide");
          modal.style.display = "none";
        }
      }
    };
  }, []);

  // useEffect(() => {
  //     // @ts-ignore
  //     window["submit"] = function () {
  //         let backDrops = document.getElementsByClassName("modal-backdrop");
  //         if (backDrops.length > 0) {
  //             backDrops[0].classList.remove("show");
  //             backDrops[0].classList.add("hide");
  //         }
  //         let modals = document.getElementsByClassName("modal");
  //         if (modals.length > 0) {
  //             modals[0].classList.remove("show");
  //             modals[0].classList.add("hide");
  //         }
  //         // let submit = document.getElementById("ongoing");
  //         // console.log("submit", submit)
  //     }
  // }, [])

  useBeforeunload((event) => {
    if (appContext.enableBeforeUnload) {
      event.preventDefault();
      alert("Are you sure to leave this pages?");
    }
  });

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <React.Suspense fallback={<UILoading />}>
        <Routes>
          <Route path={"/testSocket"} element={<MainTestWebSocket />} />
          <Route path={"/UILoading"} element={<UILoading />} />
          <Route path={"/test-gojs"} element={<TestGojs />} />
          <Route path={"/testCard"} element={<TestCard />} />
          <Route path={"/testChatWs"} element={<TestChatWs />} />
          <Route path={"/testGroupWs"} element={<TestGroupWS />} />
          <Route path={"/testKanban"} element={<TestKanban />} />
          <Route path={"/showReportPost"} element={<ShowReportPost />} />
          <Route path={"/testLazyLoad"} element={<Normal />} />
          <Route path={"/testJanus"} element={<VideoCall />} />
          <Route path={"/testOrgChart"} element={<TestOrgChart />} />
          <Route path={"/testOrgChart2"} element={<OrgChartColleagues />} />
          <Route path={"/testRuntimeURL"} element={<TestRuntimeEnv />} />
          <Route path={"/game"} element={<Game />} />
          <Route path={pathRoutes.LoginStream} element={<LoginStream />} />
          <Route path={pathRoutes.Login} element={<LoginMain />} />
          <Route path={pathRoutes.createAccount} element={<CreateAccount />} />
          <Route path={pathRoutes.forgotPassword} element={<CreateAccount />} />
          <Route path={"/"} element={<UIFirstPage />} />
          <Route path={pathRoutes.Root} element={<UIFirstPage />} />
          <Route
            path={pathRoutes.HeadstartRoot}
            element={<UIFirstPageStream />}
          />
          <Route path={pathRoutes.Stream} element={<StreamForUser />} />
          <Route path={pathRoutes.headstartinfo} element={<StreamInfo />} />
          <Route path={pathRoutes.headstartwatch} element={<StreamInfoWatch />} />
          <Route path={pathRoutes.googleLogin} element={<GoogleLogin />} />
          <Route path={pathRoutes.facebookLogin} element={<FacebookLogin />} />
          <Route path={pathRoutes.azureLogin} element={<AzureLogin />} />
          <Route path="/not-found" element={<NotFound />} />
          <Route path={pathRoutes.Privacy} element={<Privacy />} />
          <Route
            path={pathRoutes.fileCheckAccess}
            element={<UICoFileAccess />}
          />
          <Route path='/' element={<PrivateRoute />}>
            <Route path={pathRoutes.Feed} element={<NewActionCenter />} />
            <Route path={pathRoutes.Group} element={<Group />} />
            <Route path={pathRoutes.Main} element={<LoginMain />} />
            <Route path={pathRoutes.Apps} element={<Apps />} />
            <Route path={pathRoutes.MicroApp} element={<UIMicroApp />} />
            <Route
              path={pathRoutes.MicroAppPD}
              element={<UIMicroAppPD />}
            />
            {/*<Route path={pathRoutes.File} element={<UICoFile/>} />*/}
            {/*<Route path={pathRoutes.File} element={<Files><Outlet /></Files>}>*/}
            <Route path={pathRoutes.File} element={<UICoFile />} />
            <Route path={pathRoutes.File + "/id/:id"} element={<UICoFile />} />
            <Route path={pathRoutes.File + "/id/:id/folder/"} element={<UICoFile />} />
            <Route path={pathRoutes.File + "/id/:id/folder/shared-with-me/:dir"} element={<UICoFile isShared={true} />} />
            <Route path={pathRoutes.File + "/id/:id/folder/:dir"} element={<UICoFile />} />
            <Route path={pathRoutes.File + "/id/:id/tab/:tab"} element={<UICoFile />} />
            {/*</Route>*/}
            <Route path={pathRoutes.Chat} element={<UIChat />} />
            <Route path={pathRoutes.Video} element={<UIVideo />} />
            {/*<Route path={pathRoutes.Example} element={<UIMicroApp/>} />*/}
            <Route path={pathRoutes.Home} element={<Home />} />
            <Route path={pathRoutes.Post} element={<Home />} />
            <Route
              path={pathRoutes.createGroup}
              element={<CreateGroup />}
            />
            <Route path={pathRoutes.Profile} element={<MyCenter><Outlet /></MyCenter>}>
              <Route path="/profile" element={<Posts />} />
              <Route path="/profile/post" element={<Posts />} />
              <Route path="/profile/save" element={<Save />} />
              <Route path="/profile/request" element={<Requests />} />
              <Route path="/profile/friend" element={<Friends />} />
              <Route path="/profile/group" element={<Groups />} />
              <Route path="/profile/live" element={<Lives />} />
              <Route path="/profile/conference" element={<Conferences />} />
              <Route path="*" element={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}><Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
              // extra={<Button type="primary">Back Home</Button>}
              /></div>} />
            </Route>
            <Route path={pathRoutes.groupCommunityPath} element={<Community><Outlet /></Community>} >
              <Route path={pathRoutes.groupCommunityPath} element={<CommunityNewFeed />} />
              <Route path={pathRoutes.groupCommunityPath + "/file"} element={<UICoFileCommunity />} />
              <Route path={pathRoutes.groupCommunityPath + "/folder/"} element={<UICoFileCommunity />} />
              <Route path={pathRoutes.groupCommunityPath + "/folder/:dir"} element={<UICoFileCommunity />} />
              <Route path={pathRoutes.groupCommunityPath + "/tab/:tab"} element={<UICoFileCommunity />} />
              <Route path={pathRoutes.groupCommunityPath + "/member"} element={<CommunityMemberManage />} />
              <Route path={pathRoutes.groupCommunityPath + "/app"} element={<Apps />} />
              <Route path={pathRoutes.groupCommunityPath + "/chat"} element={<ChatGroupCommunity />} />
              <Route path={pathRoutes.groupCommunityPath + "/invite"} element={<InviteChat />} />
              <Route path={pathRoutes.groupCommunityPath + "/setting/group"} element={<CreateGroup community />} />
              <Route path={pathRoutes.groupCommunityPath + "/setting/privacy"} element={<PrivacyCommunitySetting />} />
              <Route path="*" element={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100%" }}><Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
              // extra={<Button type="primary">Back Home</Button>}
              /></div>} />
            </Route>
            <Route path={pathRoutes.Setting} element={<Setting />} />
            <Route path={pathRoutes.addFile} element={<AddFile />} />
            <Route
              path={pathRoutes.HomeCaseManagement}
              element={<HomeCaseManagement />}
            />
            <Route
              path={pathRoutes.SettingCaseManagement}
              element={<SettingCaseManagement />}
            />
            <Route
              path={pathRoutes.ViewAllDocuments}
              element={<ViewAllDocuments />}
            />
            <Route
              path={pathRoutes.CaseDetailsPath}
              element={<CaseDetails />}
            />
            <Route path={pathRoutes.Template} element={<Template />} />

            <Route
              path={pathRoutes.TemplateInfo}
              element={<TemplateInfo />}
            >
              <Route path={pathRoutes.TemplateInfoPath} element={<TemplateInfo />} />
            </Route>
            <Route
              path={pathRoutes.conference}
              element={<VideoConference />}
            />
            <Route
              path={pathRoutes.UICaseDesignMaster}
              element={<UICaseDesignMaster />}
            />
            {/*<Route*/}
            {/*    path={pathRoutes.NewDocumentPath}*/}
            {/*    element={<CaseDesignDocument/>}*/}
            {/*/>*/}
            <Route
              path={pathRoutes.NewDocument}
              element={<CaseDesignDocument><Outlet /></CaseDesignDocument>}
            >
              <Route path="/document-pages/id/:id" element={<AddNewDocument />} />
              <Route path="/document-pages" element={<AddNewDocument />} />
              <Route path="/document-pages/rule-setting/:id" element={<SettingRule />} />
            </Route>
            <Route path={pathRoutes.Rule} element={<Rule />} />
            <Route
              path={pathRoutes.SettingRulePath}
              element={<SettingRule />}
            />
            <Route path={pathRoutes.Integration} element={<Integration />} />
            <Route path={pathRoutes.SettingIntegrationPath} element={<SettingIntegration />} />
            <Route path={pathRoutes.Organization} element={<Organization />} />
            <Route path={pathRoutes.SettingOrganizationPath} element={<SettingOrganization />} />
            {/*<Route path={pathRoutes.call} components={VideoConference} />*/}
            <Route path={pathRoutes.checkIn} element={<UICheckIn />} />
            <Route path={pathRoutes.Live} element={<LiveOnDemand />} />
            <Route path={pathRoutes.PersonalLive} element={<Live />} />
            <Route path={pathRoutes.GroupLive} element={<Live />} />
            <Route path={pathRoutes.StreamAdmin} element={<Stream />} />
            <Route path={pathRoutes.Board} element={<TestBoard />} />
            <Route path={pathRoutes.UserReward} element={<UserReward />} />
            <Route
              path={pathRoutes.DraggableBoard}
              element={<TestBoard2 />}
            />
            <Route
              path={pathRoutes.personalCall}
              element={<VideoCallV2 />}
            />
            {/*<Route*/}
            {/*    path={pathRoutes.conferenceOptions}*/}
            {/*    components={VideoConference}*/}
            {/*/>*/}
            <Route
              path={pathRoutes.centercitizenprofile}
              element={<CenterCitizenprofile />}
            />
            <Route
              path={pathRoutes.citizenprofile}
              element={<Citizenprofile />}
            />
            <Route
              path={pathRoutes.StreamSeeMore}
              element={<StreamSeeMore />}
            />
            {/*<Route*/}
            {/*    path={pathRoutes.groupCommunity}*/}
            {/*    element={<Community/>}*/}
            {/*/>*/}
            {/*<Route path={pathRoutes.groupCommunity + "/id/:id"} element={<UICoFile/>} />*/}
            {/*<Route path={pathRoutes.groupCommunity + "/id/:id/folder/"} element={<UICoFile/>} />*/}
            {/*<Route path={pathRoutes.groupCommunity + "/id/:id/folder/:dir"} element={<UICoFile/>} />*/}
            {/*<Route path={pathRoutes.groupCommunity + "/id/:id/tab/:tab"} element={<UICoFile/>} />*/}
            <Route
              path={pathRoutes.InitHeadStart}
              element={<InitHeadStart />}
            />
            <Route
              path={pathRoutes.VirtualBackground}
              element={<VirtualBackground />}
            />
            <Route path={pathRoutes.Custom} element={<UICustom />} />
            <Route path="*" element={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}><Result
              status="404"
              title="404"
              subTitle="Sorry, the page you visited does not exist."
            // extra={<Button type="primary">Back Home</Button>}
            /></div>} />

          </Route>
          <Route path="*" element={<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}><Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
          // extra={<Button type="primary">Back Home</Button>}
          /></div>} />
          {/*<Route path={pathRoutes.Home} element={<Home/>}/>*/}
          {/*<Route*/}
          {/*    path={pathRoutes.Home}*/}
          {/*    element={auth ? <Home/> : <Navigate to={pathRoutes.Login}/>}*/}
          {/*/>*/}
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}
